// COPIA da TMA#718 di CriGio @ 8e60f982: src/lib/burraco/impostazioni.ts — SOLO le tre funzioni generiche (`leggiBooleano`, `scriviBooleano`, `storageDelDispositivo`), ora esportate;
// le chiavi, i valori di partenza e le impostazioni del burraco restano in quel file. Lo stesso schema di `lib/backgammon/theme.ts`: `localStorage` puo' LANCIARE in una WebView
// con i dati di sito bloccati, non solo tornare vuoto, quindi ogni accesso e in `try/catch` e un valore illeggibile vale il predefinito.

export type Lettura = Pick<Storage, 'getItem'> | null;
export type Scrittura = Pick<Storage, 'setItem'> | null;

/** Solo «true» e «false» sono valori: qualunque altra cosa (assente, vuoto, «1», un testo qualunque) vale il predefinito, mai «acceso». */
export function leggiBooleano(storage: Lettura, chiave: string, predefinito: boolean): boolean {
  try {
    const raw = storage?.getItem(chiave);
    return raw === 'true' ? true : raw === 'false' ? false : predefinito;
  } catch {
    return predefinito;
  }
}

export function scriviBooleano(storage: Scrittura, chiave: string, valore: boolean): void {
  try {
    storage?.setItem(chiave, String(valore));
  } catch {
    /* una preferenza che non si salva non e un errore da mostrare: vale per questa visita */
  }
}

/** Lo storage del dispositivo, o `null`: anche solo toccare `window.localStorage` puo lanciare (cookie e dati di sito bloccati). */
export function storageDelDispositivo(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
